import React from "react";
import Form from "../common/form";
import auth from "../../services/authService";
import { Redirect } from "react-router-dom";
import { signIn, confirmSignIn } from "aws-amplify/auth";
import SignUpForm from "./signUpForm";
import LoginForm from "./loginForm";

export default class Login extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        username: "",
        password: "",
        newPassword: "",
        confirmNewPassword: "",
        mfaCode: "",
      },
      mfaStatus: false,
      mfaHelp: false,
      changePassword: false,
      errors: {},
    };
  }

  componentDidMount() {
    this.props.handleBackgroundUpdate();
  }

  handleDataUpdate = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    delete errors[input.name];

    const data = { ...this.state.data };
    data[input.name] = input.value;

    this.setState({ data, errors });
  };

  validateForm = () => {
    const { username, password } = this.state.data;
    return username.length > 0 && password.length > 0;
  };

  validateMFAForm = () => {
    const { username, password, mfaCode } = this.state.data;
    return username.length > 0 && password.length > 0 && mfaCode.length > 5;
  };

  validateCompleteSignUpFormMatch = () => {
    const { newPassword, confirmNewPassword } = this.state.data;
    return confirmNewPassword.length > 7 && newPassword === confirmNewPassword;
  };

  validateCompleteSignUpFormLength = () => {
    const { username, newPassword } = this.state.data;
    return username.length > 0 && newPassword.length > 7;
  };

  validateCompleteSignUpFormNumber = () => {
    const { newPassword } = this.state.data;
    return /\d/.test(newPassword);
  };

  validateCompleteSignUpFormSpecialChar = () => {
    const { newPassword } = this.state.data;
    return /[$&+,:;=?@#|'<>.^*()%!_-]/.test(newPassword);
  };

  validateCompleteSignUpFormUpper = () => {
    const { newPassword } = this.state.data;
    return /[A-Z]/.test(newPassword);
  };

  validateCompleteSignUpFormLower = () => {
    const { newPassword } = this.state.data;
    return /[a-z]/.test(newPassword);
  };

  handleSubmit = async (event) => {
    if (event !== undefined) {
      event.preventDefault();
      try {
        const { data } = this.state;
        const user = await signIn({
          username: data.username,
          password: data.password,
        });
        if (
          user.nextStep?.signInStep ===
          "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED"
        ) {
          this.setState({ changePassword: true });
        } else if (
          user.nextStep?.signInStep === "CONFIRM_SIGN_IN_WITH_SMS_CODE" ||
          user.nextStep?.signInStep === "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
        ) {
          this.setState({ mfaStatus: true });
        } else if (user.isSignedIn || user.nextStep?.signInStep === "DONE") {
          window.location = "/";
        }
      } catch (e) {
        if (e.name === "PasswordResetRequiredException") {
          alert(
            e.message + ". Please use the Forgot Password link in the login page."
          );
        } else if (e.name === "NotAuthorizedException") {
          alert("Incorrect username or password. Please try again.");
        } else if (e.name === "UserNotFoundException") {
          alert("User not found. Please check your username.");
        } else {
          alert(e.message || "Login failed. Please try again.");
        }
        console.log(e);
      }
    }
  };

  handleMFASignIn = async (event) => {
    if (event !== undefined) {
      event.preventDefault();
      const { data } = this.state;
      try {
        // Just confirm the MFA challenge with the code - don't call signIn again
        const result = await confirmSignIn({
          challengeResponse: data.mfaCode,
        });

        if (result.isSignedIn || result.nextStep?.signInStep === "DONE") {
          // Token management is handled automatically by Amplify v6
          window.location = "/";
        }
      } catch (ex) {
        console.log(ex);
        alert(ex.message || "MFA verification failed. Please try again.");
      }
    }
  };

  handleCompleteSignUpSubmit = async (event) => {
    event.preventDefault();
    try {
      const { data } = this.state;
      // Just confirm with the new password - user is already in the password change flow
      const result = await confirmSignIn({
        challengeResponse: data.newPassword,
      });

      if (result.isSignedIn) {
        // Token management is handled automatically by Amplify v6
        window.location = "/";
      }
    } catch (ex) {
      console.log(ex);
      alert(ex.message || "Password change failed. Please try again.");
    }
  };

  renderLoginForm() {
    return (
      <LoginForm
        validateForm={this.validateForm}
        validateMFAForm={this.validateMFAForm}
        mfaStatus={this.state.mfaStatus}
        handleSubmit={this.handleSubmit}
        handleMFASignIn={this.handleMFASignIn}
        handleDataUpdate={this.handleDataUpdate}
      />
    );
  }

  renderCompleteSignUpForm = () => {
    const validateList = [
      this.validateCompleteSignUpFormUpper,
      this.validateCompleteSignUpFormSpecialChar,
      this.validateCompleteSignUpFormNumber,
      this.validateCompleteSignUpFormLower,
      this.validateCompleteSignUpFormLength,
      this.validateCompleteSignUpFormMatch,
    ];
    return (
      <SignUpForm
        mfaStatus={this.state.mfaStatus}
        handleCompleteSignUpSubmit={this.handleCompleteSignUpSubmit}
        handleDataUpdate={this.handleDataUpdate}
        validateList={validateList}
      />
    );
  };

  render() {
    if (auth.getCurrentUser()) return <Redirect to="/" />;

    return (
      <React.Fragment>
        {!this.state.changePassword && this.renderLoginForm()}
        {this.state.changePassword && this.renderCompleteSignUpForm()}
      </React.Fragment>
    );
  }
}
